<script setup>
import {ref} from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const isOpen = ref(true)
const props = defineProps({
  title: {type: String, required: true},
  message: {type: String, required: true},
  useInput: {type: String, required: false, default: null},
  actionType: {type: String, required: false},
});
const emit = defineEmits(['confirm', 'cancel']);
const inputValue = ref(props.useInput);

function closeModal() {
  isOpen.value = false
}

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      if (inputValue.value !== '') {
        emit('confirm', inputValue.value);
      } else {
        emit('confirm');
      }
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered" style="z-index: 1055" role="document">
          <div class="modal-content">
            <DialogPanel>
              <!-- Modal Header -->
              <div class="modal-header">
                <DialogTitle as="h5" class="modal-title">
                  {{ title }}
                </DialogTitle>
                <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
              </div>

              <!-- Modal Body -->
              <div class="modal-body">
                <div class="mb-3">
                  <p class="text-muted">{{ message }}</p>
                  <div v-if="inputValue">
                    <input
                        ref="modalInput"
                        v-model="inputValue"
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                  </div>
                </div>
              </div>

              <!-- Modal Footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">
                  {{ t('modalDialog.cancel') }}
                </button>
                <button v-if="props.actionType && props.actionType === 'DELETE'" type="button" class="btn btn-danger" @click="closeModalWith('confirm')">
                  {{ t('modalDialog.confirm') }}
                </button>
                <button v-else type="button" class="btn btn-primary" @click="closeModalWith('confirm')">
                  {{ t('modalDialog.confirm') }}
                </button>
              </div>
            </DialogPanel>
          </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>


